import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetMisFacturas, CreaFacturaDto } from '../../shared/interfaces/liquidacion';
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class FacturaService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/factura`;
  }

  getMisFacturas(): Observable<IGetMisFacturas[]> {
    return this.http.get<IGetMisFacturas[]>(`${this.baseUrl}/mis-facturas`);
  }

  createFactura(body: Omit<CreaFacturaDto,'radicado' | 'contribuyente'>): Observable<any> {
    const url = `${this.baseUrl}/crear`;
    return this.http.post<number>(url, body);
  }

  imprimirFactura(id: number): Observable<Blob> {
    const url = `${this.baseUrl}/genera-recibo-pago`;
    const params = new HttpParams().set('lote', id.toString());
    return this.http.get(url, {responseType: 'blob', params});
  }

  existe(solicitud: number): Observable<boolean> {
    const params = new HttpParams().set('solicitud', solicitud.toString());
    return this.http.get<boolean>(`${this.baseUrl}/existe`, {params});
  }

}
